import { action } from 'satcheljs';

// The actions defined here can be used publicly outside of the package, that's why the file name is external actions

/**
 * Public action to open folder permissions dialog
 * @param folderId string - Id of folder for which folder permissions should be shown/updated
 * @return folderId: string
 */
export const openFolderPermissionsDialog = action(
    'OPEN_FOLDER_PERMISSIONS_DIALOG',
    (folderId: string) => ({ folderId })
);
